import useTheme from "../hooks/UseTheme";

export default function Header() {
  const [IsDark, setIsDark] = useTheme();

  return (
    <>
      <header className={`header-container ${IsDark ? "dark" : ""}`}>
        <div className="header-content">
          <h2 className="title">Where in the world?</h2>
          <p
            className="theme-changet"
            onClick={() => {
              setIsDark(!IsDark);
              localStorage.setItem("IsDarkMode", !IsDark);
            }}
          >
            <i className={`fa-solid fa-${IsDark ? "sun" : "moon"}`}></i>
            &nbsp;&nbsp;{IsDark ? "Light" : "Dark"} Mode
          </p>
        </div>
      </header>
    </>
  );
}
